import React from 'react'

import Page from '../../../../components/pdf/Page'

import Header from './Header'
import ClientData from './sections/ClientData'
import Result from './sections/result/Result'

const PdfDocument = () => {
  return (
    <Page>
      <Header />
      <ClientData />
      <Result />
    </Page>
  )
}

export default PdfDocument
